<template>
  <dx-modal title="Solicitantes / Indicações"
            :value="show"
            @input="close"
            size="lg"
            id="modal-referral-manager">
    <referral-list @changed="changed = true" />
    <template slot="footer">
      <button class="btn" @click="close">Sair</button>
    </template>
  </dx-modal>
</template>

<script>
import referralList from './List.vue';

export default {
  components: {
    referralList,
  },
  props: {
    show: {
      type: Boolean,
    },
  },
  data() {
    return {
      changed: false,
    };
  },
  methods: {
    close() {
      this.$emit('close', this.changed);
    },
  },
};
</script>

<style lang="scss">
</style>
